import { Injectable } from '@angular/core';
import {
  ColumnGroupOperationParams, ColumnOperationParams,
  ProcessHiddenGroupsParams, ToggleColumnHiddenStateParams,
  ToggleMap
} from "../../types/table-types/column-group-toggle.types";
import {RecordTableColumnParams, ColumnsForToggling} from "../../types/records-table.types";


@Injectable({
  providedIn: 'root'
})
export class ColumnGroupToggleService {
  public processHiddenGroups({ currentColumns, columnsForToggling }: ProcessHiddenGroupsParams): RecordTableColumnParams[] {
    const columnsToToggleMap = this.buildToggleMap(columnsForToggling);
    return columnsToToggleMap.size ?
      this.applyToggleToColumns({ columns: currentColumns, toggleMap: columnsToToggleMap }) :
      currentColumns;
  }

  private buildToggleMap(columnsForToggling: ColumnsForToggling): ToggleMap {
    const map = new Map<string, boolean>();

    for (const groupId in columnsForToggling) {
      const groupColumns = columnsForToggling[groupId];
      const firstNonStickyKey = this.findToggleTargetKey(groupColumns);
      firstNonStickyKey && this.buildGroupToggleMap({ toggleMap: map, columns: groupColumns, firstKey: firstNonStickyKey });
    }

    return map;
  }

  private findToggleTargetKey(groupColumns: Array<RecordTableColumnParams>): string | null {
    for (let i = 0; i < groupColumns.length; i++) {
      const column = groupColumns[i];
      if (!column.sticky) {
        return column.key;
      }
    }

    return null;
  }

  private buildGroupToggleMap({ toggleMap, columns, firstKey }: ColumnGroupOperationParams): void {
    for (let i = 0; i < columns.length; i++) {
      const column = columns[i];
      if (!column.sticky) {
        toggleMap.set(column.key, column.key === firstKey);
      }
    }
  }

  private applyToggleToColumns({ columns, toggleMap }: ColumnGroupOperationParams): Array<RecordTableColumnParams> {
    const result = new Array(columns.length);
    let hasChanges = false;

    for (let i = 0; i < columns.length; i++) {
      const column = columns[i];
      const isFirst = toggleMap.get(column.key);

      if (isFirst === undefined) {
        result[i] = column;
      } else {
        result[i] = this.toggleColumnHiddenState({ column, isFirst });
        hasChanges = true;
      }
    }

    return hasChanges ? result : columns;
  }

  private toggleColumnHiddenState({ column, isFirst }: ToggleColumnHiddenStateParams): RecordTableColumnParams {
    const newHiddenGroup = !column.hiddenGroup;

    return isFirst ?
      this.createFirstColumnWithHiddenGroup({ column, newHiddenGroup }) :
      this.updateColumnHiddenGroup({ column, newHiddenGroup });
  }

  private createFirstColumnWithHiddenGroup({ column, newHiddenGroup }: ColumnOperationParams): RecordTableColumnParams {
    return {
      ...column,
      hiddenGroup: newHiddenGroup,
      hiddenGroupPlaceholder: newHiddenGroup
    };
  }

  private updateColumnHiddenGroup({ column, newHiddenGroup }: ColumnOperationParams): RecordTableColumnParams {
    return column.hiddenGroup === newHiddenGroup ?
      column :
      { ...column, hiddenGroup: newHiddenGroup };
  }
}
